import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { BatteryWarning, XCircle, Clock, HelpCircle, Frown, TrendingDown, CalendarX, ChevronDown } from 'lucide-react';
const pains = [{
  icon: BatteryWarning,
  title: 'Llegas cansado todos los días',
  desc: 'Sin energía ni motivación para entrenar.'
}, {
  icon: XCircle,
  title: 'Empiezas rutinas… y las abandonas',
  desc: 'La falta de constancia te hace volver siempre al mismo punto.'
}, {
  icon: Clock,
  title: 'No tienes tiempo para el gimnasio',
  desc: 'Tu rutina diaria no te deja horas libres.'
}, {
  icon: HelpCircle,
  title: 'No sabes qué ejercicios hacer',
  desc: 'Pierdes tiempo buscando videos y consejos contradictorios.'
}, {
  icon: Frown,
  title: 'Te sientes incómodo con tu cuerpo',
  desc: 'Tu confianza y autoestima disminuyen cada vez más.'
}, {
  icon: TrendingDown,
  title: 'Sientes que tu cuerpo empeora',
  desc: 'Menos energía, más cansancio y hábitos desordenados.'
}, {
  icon: CalendarX,
  title: 'Siempre dices "empiezo el lunes"',
  desc: 'Pero nunca logras sostenerlo.'
}];
export function PainPoints() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="py-10 md:py-20 px-4" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <div className="text-center mb-6 md:mb-12" data-id="element-129">
          <h2 className="text-4xl md:text-6xl font-bebas text-white mb-2" data-id="element-130">
            ¿TE PASA ESTO?
          </h2>
          <p className="text-sm md:text-xl text-zinc-400" data-id="element-131">
            Si te identificas con esto, esta página es para ti:
          </p>
        </div>

        {/* Mobile: collapsible list. Desktop: full grid */}
        <div className="md:hidden space-y-2 mb-8" data-id="element-132">
          {pains.map((pain, i) => {
          const isOpen = open === i;
          return <motion.div key={i} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.04
          }} className="bg-zinc-900/50 border border-zinc-800 rounded-xl overflow-hidden" data-id="element-133">
                <button onClick={() => setOpen(isOpen ? null : i)} className="w-full flex items-center gap-3 p-3 text-left" data-id="element-134">
                  <div className="bg-red-500/10 p-2 rounded-lg shrink-0" data-id="element-135">
                    <pain.icon className="w-4 h-4 text-red-500" data-id="element-136" />
                  </div>
                  <h3 className="font-bold text-white text-sm flex-1" data-id="element-137">
                    {pain.title}
                  </h3>
                  <ChevronDown className={`w-4 h-4 text-zinc-500 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} data-id="element-138" />
                </button>
                <AnimatePresence data-id="element-139">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-140">
                      <p className="text-zinc-400 text-xs px-3 pb-3 pl-12" data-id="element-141">
                        {pain.desc}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        {/* Desktop grid */}
        <div className="hidden md:grid grid-cols-2 gap-4 mb-16" data-id="element-142">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.05
        }} whileHover={{
          y: -2,
          borderColor: 'rgba(239,68,68,0.5)'
        }} className={`bg-zinc-900/50 border border-zinc-800 p-5 rounded-xl flex gap-4 items-start ${i === pains.length - 1 ? 'col-span-2 max-w-md mx-auto w-full' : ''}`} data-id="element-143">
              <div className="bg-red-500/10 p-3 rounded-lg shrink-0" data-id="element-144">
                <pain.icon className="w-6 h-6 text-red-500" data-id="element-145" />
              </div>
              <div data-id="element-146">
                <h3 className="font-bold text-white text-lg mb-1" data-id="element-147">
                  {pain.title}
                </h3>
                <p className="text-zinc-400 text-sm" data-id="element-148">{pain.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-500/10 border border-brand-500/30 p-5 md:p-8 rounded-2xl text-center" data-id="element-149">
          <h3 className="text-2xl md:text-4xl font-bebas text-brand-500 leading-tight" data-id="element-150">
            ¿CUÁNTO TIEMPO MÁS VAS A SEGUIR POSTERGANDO TU CAMBIO?
          </h3>
        </motion.div>
      </div>
    </section>;
}